export default "__VITE_ASSET__d38bf7bc__"